// LAS RESPUESTAS DEL CIERRE DEL DÍA, EN UN SOLO SITIO (Jesús, vídeos del 20-10).
//
// Los botones de «¿Entrenaste hoy?», «¿Hiciste el cardio pautado?» y «¿Tomaste tus
// suplementos?» y cómo se nombra luego cada respuesta guardada. Lo leen el cierre del día
// (CheckInsPage: botones, resumen e historial) y la ficha del entrenador (CoachCheckins):
// antes cada uno tenía su copia y el entrenador no sabía leer los valores de hoy.
//
// LOS VALORES GUARDADOS NO CAMBIAN, SOLO LAS ETIQUETAS: `descanso` es «Hoy tocaba descanso»,
// `no` es «Me tocaba entrenar, pero no fui» y en el cardio `no_tocaba` es «No tenía». El
// 20-10 entró `no_pautados` en los suplementos («No los tengo pautados»): no es un día sin
// tomarlos, es que no hay pauta. Lo cuenta así `core/actividad_mensual.cierres_del_periodo`.
// El 26-10 entran `adaptado` y `a_medias` en el entreno y las preguntas nuevas del check-in
// de Enrique (horas de sueño, rendimiento, sensaciones entrenando, actividad y cantidad de
// comida).

const aMapa = (opciones) => Object.fromEntries(opciones.map(o => [o.v, o.l]));

// LAS PALABRAS DEL CHECK-IN DEL 26-10 (artefacto de Enrique). El entreno pasa de tres a
// cinco respuestas: dos nuevas (`adaptado`, `a_medias`) y las tres de siempre con otra
// etiqueta. El cardio y los suplementos solo cambian de etiqueta.
export const ENTRENO_OPCIONES = [
    { v: 'si', l: 'Sí, tal cual' },
    { v: 'adaptado', l: 'Al 90 %, tuve que adaptar cosas' },
    { v: 'a_medias', l: 'No lo pude terminar, lo dejé a medias' },
    { v: 'descanso', l: 'Hoy tocaba descanso' },
    { v: 'no', l: 'Me tocaba entrenar, pero no fui' },
];

// «Solo si marcó una de las tres primeras»: las dos preguntas que cuelgan del entreno.
// La misma lista que `core/respuestas_del_cierre.ENTRENO_HECHO` en el servidor.
export const ENTRENO_HECHO = ['si', 'adaptado', 'a_medias'];

export const RENDIMIENTO_OPCIONES = [
    { v: 'muy_bien', l: 'Muy bien: subí pesos o repeticiones' },
    { v: 'bien', l: 'No mejoré mis marcas, pero rendí bien' },
    { v: 'aceptable', l: 'Aceptable, pero mejorable' },
    { v: 'mal', l: 'Mal, hoy no tenía el día' },
];

export const SENSACIONES_ENTRENO_OPCIONES = [
    { v: 'pletorico', l: 'Pletórico, podía con todo' },
    { v: 'bien', l: 'Me sentí bien, con energía' },
    { v: 'regular', l: 'Regular, lo justo para terminar y gracias' },
    { v: 'flojo', l: 'Muy flojo' },
];

export const CARDIO_OPCIONES = [
    { v: 'si', l: 'Sí' },
    { v: 'no_tocaba', l: 'No tenía' },
    { v: 'no', l: 'No. Tenía, pero no lo hice' },
];

// «¿Fuiste lo suficientemente activo?». Sustituye a «¿Te moviste lo suficiente?»: el
// servidor sigue escribiendo `movimiento` a partir de esta (`core/respuestas_del_cierre`).
export const ACTIVIDAD_OPCIONES = [
    { v: 'master', l: 'Nivel máster' },
    { v: 'creces', l: 'Cumplí con creces' },
    { v: 'minimo', l: 'Llegué al mínimo' },
    { v: 'cerca', l: 'No llegué al mínimo, pero quedé cerca' },
    { v: 'menos_5000', l: 'Menos de 5.000 (deja el móvil y ponte a andar ahora mismo)' },
];

export const HORAS_SUENO_OPCIONES = [
    { v: 'menos_5', l: 'Menos de 5' },
    { v: '5_a_6_5', l: 'Entre 5 y 6 y media' },
    { v: '6_5_a_8_5', l: 'Entre 6 y media y 8 y media' },
    { v: 'mas_8_5', l: 'Más de 8 y media' },
];

export const CANTIDAD_COMIDA_OPCIONES = [
    { v: 'demasiada', l: 'Demasiado para mí, no llego aunque me esfuerce' },
    { v: 'cuesta', l: 'Me lo como todo, pero me cuesta terminar las comidas' },
    { v: 'perfecta', l: 'Perfecta: lo suficiente para no estar saturado y llegar con hambre a la siguiente' },
    { v: 'mas_bien', l: 'Comería bastante más, pero bien' },
    { v: 'poca_aguanto', l: 'Poco, paso hambre, pero aguanto' },
    { v: 'poca_salto', l: 'Poco, paso hambre y me salto la dieta con frecuencia' },
];

export const SUPLES_OPCIONES = [
    { v: 'si', l: 'Sí, toda' },
    { v: 'no_todos', l: 'No toda' },
    { v: 'no', l: 'No tomé nada' },
    { v: 'no_pautados', l: 'No los tengo pautados por petición propia' },
];

// LOS DOS VALORES VIEJOS DEL ENTRENO, TRADUCIDOS AQUÍ Y SOLO AQUÍ: hay cierres escritos
// con ellos y sin esto se leerían en blanco. «Sí, pero no lo puse» dijo que sí; «No
// entrené», que no. Todo el que lee `entreno_respuesta` pasa antes por `entrenoDeHoy`.
const ENTRENO_VIEJO = { si_no_lo_puse: 'si', no_entrene: 'no' };
export const entrenoDeHoy = (valor) => ENTRENO_VIEJO[valor] || valor || null;

const _ENTRENO_ETIQUETA = aMapa(ENTRENO_OPCIONES);
export const ENTRENO_VALOR = Object.fromEntries(
    [...Object.keys(_ENTRENO_ETIQUETA), ...Object.keys(ENTRENO_VIEJO)]
        .map(v => [v, _ENTRENO_ETIQUETA[entrenoDeHoy(v)]]));
export const CARDIO_VALOR = aMapa(CARDIO_OPCIONES);
export const SUPLES_VALOR = aMapa(SUPLES_OPCIONES);
export const RENDIMIENTO_VALOR = aMapa(RENDIMIENTO_OPCIONES);
export const SENSACIONES_ENTRENO_VALOR = aMapa(SENSACIONES_ENTRENO_OPCIONES);
export const ACTIVIDAD_VALOR = aMapa(ACTIVIDAD_OPCIONES);
export const HORAS_SUENO_VALOR = aMapa(HORAS_SUENO_OPCIONES);
export const CANTIDAD_COMIDA_VALOR = aMapa(CANTIDAD_COMIDA_OPCIONES);

// ¿Esa respuesta es un fallo? «No tocaba», «No tenía» y «No los tengo pautados» no lo son:
// ni bueno ni malo; «Al 90 %» y «A medias» tampoco: entrenó. Sirve para el color de la
// ficha del entrenador.
const FALLOS = {
    entreno: new Set(['no']),
    cardio: new Set(['no']),
    suplementos: new Set(['no', 'no_todos']),
};
const BIEN = new Set(['si', 'adaptado']);

export const tonoDeRespuesta = (pregunta, crudo) => {
    const valor = pregunta === 'entreno' ? entrenoDeHoy(crudo) : crudo;
    if (valor == null || valor === '') return null;
    if (FALLOS[pregunta]?.has(valor)) return 'fallo';
    if (BIEN.has(valor)) return 'bien';
    return 'neutro';
};
